import React from 'react';
import styled from 'astroturf/react';

import { isDownloadRead, modalVersion } from '../openerIntent';
import type { ArmSpec } from '../armRegistry';

const LABEL = 'Your copy is ready. Sign in to claim it.';

// Same footprint as YourPaperCard's default "Your paper" chip (absolute,
// pointer-events: none, min 28px tall) so swapping it never reflows the
// card. The label is ~4x longer than "Your paper": it must wrap within the
// card instead of nowrap-overflowing the modal edge on narrow phones.
const Chip = styled.div`
  position: absolute;
  top: -14px;
  left: var(--spacing-xs-12, 12px);
  z-index: 1;
  pointer-events: none;
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  max-width: calc(100% - 24px);
  padding: 2px var(--spacing-xs-8, 8px);
  border-radius: var(--border-radius-radius-md, 8px);
  background: var(--primary-brand, #0645b1);
  color: var(--text-white, #ffffff);
  font-family: var(--type-font-family-sans-serif, 'DM Sans', sans-serif);
  font-size: 11px;
  font-weight: 500;
  line-height: 1.3;
`;

const ClaimTicketChip: React.FC = () => <Chip>{LABEL}</Chip>;

export const claimTicketSpec: ArmSpec = {
  slots: (ctx) => {
    if (modalVersion(ctx.detail) !== 'paper_card') return undefined;
    if (!isDownloadRead(ctx.detail)) return undefined;
    return { anchorChip: <ClaimTicketChip /> };
  },
  stamp: (ctx) => ({
    render_state:
      modalVersion(ctx.detail) === 'paper_card' && isDownloadRead(ctx.detail)
        ? 'rendered'
        : 'fallback',
  }),
};
